import { Theme } from '@mui/material';
import pariTheme from 'src/themes/pariTheme';
import homebarTheme from 'src/themes/homebarTheme';
import { AppSubdomains } from 'src/types/common';

export const ThemeTypes = AppSubdomains;

const THEMES: { [key in AppSubdomains]: Theme } = {
  [ThemeTypes.Homebar]: homebarTheme,
  [ThemeTypes.Pari]: pariTheme,
  [ThemeTypes.Terea]: pariTheme,
} as const;

export default THEMES;
